(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-zt-color-selector]').forEach(setup);
  }

  function setup(root) {
    var variantPicker = root.closest('variant-selects, variant-radios');
    if (!variantPicker) return;

    var dataEl = root.querySelector('[data-zt-color-variant-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var variants = data.variants || [];
    var colorPos = Number(data.colorPos);

    var colorGroup = variantPicker.querySelector(
      '[data-zt-is-color-option="true"]'
    );

    if (!colorGroup) return;

    var colorInputs = Array.from(
      colorGroup.querySelectorAll('input[type="radio"]')
    );

    var colorSelect = colorGroup.querySelector('select');

    var colorValues = [];

    if (colorInputs.length) {
      colorValues = colorInputs.map(function (input) {
        return input.value;
      });
    } else if (colorSelect) {
      colorValues = Array.from(colorSelect.options).map(function (option) {
        return option.value;
      });
    }

    if (!colorValues.length) return;

    var list = root.querySelector('[data-zt-color-list]');
    var triggerValue = root.querySelector('[data-zt-color-trigger-value]');
    var details = root.querySelector('[data-zt-color-details]');

    if (!list || !triggerValue) return;

    function getOptionGroups() {
      return Array.from(
        variantPicker.querySelectorAll(
          'fieldset, .product-form__input--dropdown'
        )
      );
    }

    function getCurrentSelections() {
      return getOptionGroups().map(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) return checked.value;

        var select = group.querySelector('select');
        if (select) return select.value;

        return null;
      });
    }

    function findVariant(colorValue) {
      var selections = getCurrentSelections();
      selections[colorPos] = colorValue;

      return variants.find(function (variant) {
        var opts = [variant.option1, variant.option2, variant.option3];

        return opts.every(function (value, index) {
          return selections[index] == null || value === selections[index];
        });
      });
    }

    function getStatus(variant) {
      if (variant && Number(variant.inventory_quantity) > 0) {
        return 'IN STOCK';
      }

      return 'MADE TO ORDER';
    }

    function getCurrentColor() {
      var checked = colorGroup.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value;

      if (colorSelect) return colorSelect.value;

      return triggerValue.textContent.trim();
    }

    function chooseColor(color) {
      var radio = colorInputs.find(function (input) {
        return input.value === color;
      });

      if (radio) {
        radio.click();
      } else if (colorSelect) {
        colorSelect.value = color;
        colorSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }

      triggerValue.textContent = color;

      if (details) {
        details.removeAttribute('open');
      }

      setTimeout(render, 50);
    }

    function render() {
      var currentColor = getCurrentColor();
      triggerValue.textContent = currentColor;

      list.innerHTML = '';

      colorValues.forEach(function (color) {
        var variant = findVariant(color);
        var status = getStatus(variant);

        var li = document.createElement('li');
        li.className = 'zt-color-item';

        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'zt-color-option';

        if (color === currentColor) {
          button.classList.add('is-selected');
        }

        var name = document.createElement('span');
        name.className = 'zt-color-option-name';
        name.textContent = color;

        var statusText = document.createElement('span');
        statusText.className =
          'zt-color-option-status ' +
          (status === 'IN STOCK' ? 'is-in-stock' : 'is-made-to-order');

        statusText.textContent = status;

        button.appendChild(name);
        button.appendChild(statusText);

        button.addEventListener('click', function () {
          chooseColor(color);
        });

        li.appendChild(button);
        list.appendChild(li);
      });
    }

    variantPicker.addEventListener('change', function () {
      setTimeout(render, 50);
    });

    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();